import { api } from "./client";
import type { ObjectTypeSummary, ObjectTypeDetail } from "./types";

export async function listObjectTypes(caseId?: string) {
  const { data } = await api.get<ObjectTypeSummary[]>("/object-types", {
    params: caseId ? { caseId } : undefined,
  });
  return data;
}

export async function getObjectType(id: string) {
  const { data } = await api.get<ObjectTypeDetail>(`/object-types/${id}`);
  return data;
}

export async function createObjectType(body: {
  name: string;
  pluralName: string;
  icon?: string | null;
  color?: string | null;
  displayOrder?: number;
}) {
  const { data } = await api.post<ObjectTypeDetail>("/object-types", body);
  return data;
}

export async function updateObjectType(
  id: string,
  body: Partial<{
    name: string;
    pluralName: string;
    icon: string | null;
    color: string | null;
    displayOrder: number;
  }>,
) {
  const { data } = await api.patch<ObjectTypeDetail>(
    `/object-types/${id}`,
    body,
  );
  return data;
}

export async function deleteObjectType(id: string) {
  await api.delete(`/object-types/${id}`);
}
